/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  ClickAwayListener,
  Divider,
  Drawer,
  Input,
  List,
  ListItem,
  ListItemButton,
  Menu,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import {
  useLazyGetUserQuery,
  usePostLogoutMutation,
} from "../../../service/auth";
import { useAppDispatch, useAppSelector } from "../../../hooks/store";
import {
  getFromStorage,
  removeFromStorage,
  setToStorage,
} from "../../../constants/storage";
import { STORAGE_KEYS } from "../../../constants/storageKeys";
import {
  getRole,
  getToken,
  resetAuth,
  role,
  setCredentials,
} from "../../../reducers/authSlice";
import { showError, showToast } from "../../../constants/toast";
import useAuth from "../../../hooks/useAuth";
import LogoutModal from "../../../Modals/logout";
import { useLazyGetNotificationsQuery } from "../../../service/tutorApi";

const TutorHeader = () => {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };
  const roleName = useAppSelector(getRole);
  const [getNotifications] = useLazyGetNotificationsQuery();
  const [notifications, setNotifcations] = useState<any>([]);
  const userDetails = useAuth();
  const dispatch = useAppDispatch();
  const [getProfile] = useLazyGetUserQuery();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement> | any) => {
    setAnchorEl(event.currentTarget);
  };
  const [notificationAnchorEl, setNotificationAnchorEl] = useState<null | HTMLElement>(null);
  // Notification menu
  const handleNotificationClick = (event: React.MouseEvent<HTMLElement>) => {
    setNotificationAnchorEl(event.currentTarget);
  };
  const handleNotificationClose = () => {
    setNotificationAnchorEl(null);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick3 = (e: React.MouseEvent<HTMLElement>) => {
    // Toggle open/close on figure click
    if (anchorEl) {
      handleClose();
    } else {
      setAnchorEl(e.currentTarget);
    }
  };
  const handleClose3 = () => {
    setAnchorEl(null);
  };
  const setRole = () => {
    dispatch(role({ roleName: "tutor" }));
  };
  const [openLog, setOpenLog] = useState<boolean>(false);
  const handleCloseLog = () => {
    setOpenLog(false);
  };

  const [notiType, setNotiType] = React.useState("0");
  const handleChange = (event: SelectChangeEvent) => {
    setNotiType(event.target.value as string);
  };
  const tokenFromRed = useAppSelector(getToken);

  const token = getFromStorage(STORAGE_KEYS.token);
  const fetchUser = async () => {
    try {
      const res = await getProfile({}).unwrap();
      if (res?.statusCode === 200) {
        dispatch(
          setCredentials({
            user: res?.data || null,
            token: token || null,
          })
        );
      }
    } catch (error: any) {
      showError(error?.data?.message);
    }
  };

  useEffect(() => {
    if (window) {
      window.scrollTo({ top: 0, behavior: "auto" });
    }
  }, []);

  useEffect(() => {
    if (tokenFromRed && roleName === "tutor") {
      fetchUser();
    }
  }, []);

  useEffect(() => {
    setRole();
  }, []);

  const fetchProfile = () => {
    const token = getFromStorage(STORAGE_KEYS.token);
    const userData = getFromStorage(STORAGE_KEYS.user);
    if (token) {
      dispatch(
        setCredentials({
          user: userData || null,
          token: token || null,
        })
      );
      dispatch(role({ roleName: "tutor" }));
    }
  };

  const fetchNotification = async () => {
    try {
      const res = await getNotifications({}).unwrap();
      if (res?.statusCode === 200) {
        setNotifcations(res?.data);
      }
    } catch (error: any) {
      showError(error?.data?.message);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  useEffect(() => {
    if (roleName === "tutor") fetchNotification();
  }, []);

  return (
    <>
      <header className="site_header v2">
        <div className="main_header">
          <div className="conta_iner v2">
            {/* <nav>
              <IconButton
                className="icon_btn site_hamburgur"
                onClick={toggleDrawer(true)}
              >
                <span></span>
              </IconButton>
              <a
                onClick={() => navigate("/tutor/dashboard")}
                className="site_logo"
              >
                <figure>
                  <img src={`/static/images/logo.png`} alt="logo" />
                </figure>
              </a>
              <div className="icon_flex">
                <IconButton
                  className="icon_btn"
                  id="notification-button"
                  aria-controls={open1 ? "notification-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open1 ? "true" : undefined}
                  onClick={handleClick}
                >
                  <figure>
                    <img src={`/static/images/bell_icon.svg`} alt="img" />
                  </figure>
                </IconButton>
              
              </div>
            </nav> */}
            <nav>



              <div className="header_lts">
                <a
                  onClick={() => (navigate("/"))}
                  className="site_logo"
                >
                  <figure>
                    <img src={`/static/images/logo.png`} alt="logo" />
                  </figure>
                </a>

                <div className="input_group">
                  <Input className="form_control" placeholder="Search" />
                  <span>
                    <img src={`/static/images/search-outline.svg`} alt="" />
                  </span>
                </div>
              </div>

              <div className="icon_flex">
                <a onClick={() => navigate("/tutor/home")}>
                  <figure>
                    <img src="/static/images/home.svg" alt="" />
                    <figcaption>Home</figcaption>
                  </figure>
                </a>
                <a onClick={() => navigate('/tutor/dashboard')} >
                  <figure>
                    <img src="/static/images/videos.svg" alt="" />
                    <figcaption>Dashboard</figcaption>
                  </figure>
                </a>

                <a >
                  <figure>
                    <img src={`/static/images/profile-2user.svg`} alt="" />
                    <figcaption>Pairing</figcaption>
                  </figure>
                </a>

                <a onClick={() => navigate('/tutor/chat')}>
                  <figure>
                    <img src="/static/images/inbox_icon.svg" alt="" />
                    <figcaption>Inbox</figcaption>
                  </figure>
                </a>

                <a onClick={() => navigate('/tutor/classes')} >
                  <figure>
                    <img src="/static/images/classes.svg" alt="" />
                    <figcaption>Create class</figcaption>
                  </figure>
                </a>
                <a >
                  <ClickAwayListener onClickAway={handleClose3}>
                    <figure className="profile" onClick={handleClick3}>
                      <img
                        src={userDetails?.image || "/static/images/amelia.png"}
                        alt=""
                      />
                      <figcaption>
                        {userDetails?.name || ""}{" "}
                        <span>
                          <img src={`/static/images/drop_icon.svg`} alt="" />
                        </span>{" "}
                      </figcaption>
                      <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleClose3}
                        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                        transformOrigin={{ vertical: "top", horizontal: "left" }}
                      >
                        <MenuItem onClick={() => setOpenLog(true)}>Logout</MenuItem>
                      </Menu>
                    </figure>
                  </ClickAwayListener>
                </a>


                {token ? (
                  <IconButton
                    className="icon_btn"
                    id="notification-button"
                    aria-controls={notificationAnchorEl ? "notification-menu" : undefined}
                    aria-expanded={notificationAnchorEl ? "true" : undefined}
                    aria-haspopup="true"
                    onClick={handleNotificationClick}
                  >
                    <figure>
                      <img src={`/static/images/bell_icon.svg`} alt="img" />
                    </figure>
                  </IconButton>
                ) : null}
                <Menu
                  className="noti_box"
                  id="notification-menu"
                  anchorEl={notificationAnchorEl}
                  open={Boolean(notificationAnchorEl)}
                  onClose={handleNotificationClose}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                >
                  <div className="head">
                    <div className="lt_s">
                      <h2>Notifications</h2>
                    </div>
                  </div>
                  <ul className="body">
                    {notifications?.newNotification?.length ? (
                      <h6>Recent notifications</h6>
                    ) : (
                      ""
                    )}

                    {notifications?.newNotification?.length
                      ? notifications?.newNotification?.map((item: any) => {
                        return (
                          <>
                            <li
                              onClick={() => navigate("/tutor/my-bookings")}
                              style={{
                                backgroundColor: "lightgray",
                                padding: "8px",
                                borderRadius: "15px",
                              }}
                            >
                              <p>
                                <strong>{item?.title}</strong> {item?.message}
                              </p>
                            </li>
                          </>
                        );
                      })
                      : ""}

                    {notifications?.oldNotification?.length ? (
                      <h6>Older notifications</h6>
                    ) : (
                      ""
                    )}
                    {notifications?.oldNotification?.length
                      ? notifications?.oldNotification?.map((item: any) => {
                        return (
                          <>
                            <li
                              onClick={() => navigate("/tutor/my-bookings")}
                              style={{ padding: "8px", borderRadius: "15px" }}
                            >
                              <p>
                                <strong>{item?.title}</strong> {item?.message}
                              </p>
                            </li>
                          </>
                        );
                      })
                      : ""}
                  </ul>
                </Menu>
              </div>
            </nav>
          </div>
        </div>
      </header>
      <LogoutModal
        open={openLog}
        setOpen={setOpenLog}
        onClose={handleCloseLog}
      />
    </>
  );
};

export default TutorHeader;
